
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../../controlador';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        public Cargando: boolean = false;
        public get Ok(): boolean
        {
            return !!this.Pedido;
        }

        public async Ejecutar()
        {
            this.Controlador.Vista.BarraDerecha.Modo = 'declaracion_iibb';
        }

    }
